import { render, staticRenderFns } from "./PaymentOrderState.vue?vue&type=template&id=023b7d2d&"
import script from "./PaymentOrderState.vue?vue&type=script&lang=ts&"
export * from "./PaymentOrderState.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports